import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderExportResponseImplEncoder } from "../../encoder/OrderExportResponseImplEncoder";

import * as CubiqTS from "../../index";
import { OrderExportResponse } from "../OrderExportResponse";

export class OrderExportResponseImpl extends ConcreteEncodable implements OrderExportResponse {
  public static enType: string = "com.bcdfx.model.event.OrderExportResponseImpl";

  /*FID=1*/
  public data: string;
  /*FID=2*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderExportResponseImplEncoder.Instance;
    this.setEncodableType(OrderExportResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderExportResponseImpl[" +
      "data=" +
      this.data +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
